// extracted by mini-css-extract-plugin
module.exports = {"InvoicedHistoryModal":"InvoicedHistoryModal_InvoicedHistoryModal__1xLvn","title":"InvoicedHistoryModal_title__1ZQMK"};